const handleApiErrors = (
  promise: Promise<any>,
  unauthorizedCallback: () => void,
  showError: (text: string) => void,
) => {
  promise.catch(({ message }) => {
    if (message === 'Unauthorized' || message === 'Forbidden') {
      unauthorizedCallback();
    } else {
      showError(message);
    }
  });
};

export default handleApiErrors;
